module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/3/2-64b27f4851d6f2edac727d5fb77b4538.jpg";